/* FYNDMAXA (2026-09-23): variantväljaren i produktkorten.

   Koden låg tidigare som ett onchange-attribut på VARJE radioknapp i VARJE
   kort: 3,4 KB per val, sex val per kort, tjugofyra kort per kategorisida.
   Det blev omkring 170 KB extra HTML på varje sidvisning och gjorde att
   toppen av sidan kom fram sent, vilket syntes som layouthopp på dator
   (CLS 0,89 i Lighthouse, 115 adresser i Dålig i Search Console).

   Logiken är oförändrad, flyttad rakt över. Lyssnaren sitter på document och
   inte på knapparna, eftersom facets.js byter ut hela #ProductGridContainer
   vid filtrering och sortering — en lyssnare på själva knappen hade dött där.
   Vaktflaggan behövs av samma skäl: filen kan laddas en gång per sektion.

   Etiketterna kommer från window.fmCardLabels, som snippeten skriver ut en
   gång per sektion (översättningen av \"slutsåld\" finns bara i Liquid). */
(function () {
  if (window.__fmCardVariantsInit) return;
  window.__fmCardVariantsInit = true;

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.dataset || !input.dataset.position) return;
    if (!input.closest || !input.closest('.card-variants')) return;

    var labels = window.fmCardLabels || {};
    var form = input.closest('form');
    if (!form) return;
    var selects = form.querySelector('select[name=id]');
    if (!selects) return;

    var checkedRadios = Array.prototype.slice.call(form.querySelectorAll('input[type=radio]:checked'));
    var sel = { option1: '', option2: '', option3: '' };
    checkedRadios.forEach(function (r) { sel[r.dataset.position] = r.value; });

    var matchedOpt = Array.prototype.slice.call(selects.options).find(function (o) {
      return (sel.option1 === '' || o.dataset.option1 === sel.option1) &&
             (sel.option2 === '' || o.dataset.option2 === sel.option2) &&
             (sel.option3 === '' || o.dataset.option3 === sel.option3);
    });

    var cardEl = input.closest('.card-wrapper');
    if (!cardEl) return;
    var btn = cardEl.querySelector('.quick-add__submit');
    var setLabel = function (lang, kort) {
      if (!btn) return;
      var a = btn.querySelector('.qa-label--long'); if (a) a.textContent = lang;
      var b = btn.querySelector('.qa-label--short'); if (b) b.textContent = kort;
    };

    if (matchedOpt) {
      selects.value = matchedOpt.value;
      if (matchedOpt.dataset.available === 'false') {
        if (btn) btn.disabled = true;
        setLabel(labels.soldOut, labels.soldOut);
      } else {
        if (btn) btn.disabled = false;
        setLabel(labels.long, labels.short);
      }
      if (matchedOpt.dataset.imageUrl) {
        var img = cardEl.querySelector('.card__media img');
        if (img) {
          img.srcset = matchedOpt.dataset.imageSrcset;
          img.src = matchedOpt.dataset.imageUrl;
        }
      }
    } else {
      if (btn) btn.disabled = true;
      setLabel(labels.unavailable, labels.unavailable);
    }

    var group = input.closest('.card-variants');
    var circles = group.querySelectorAll('.card-swatch-circle');
    Array.prototype.forEach.call(circles, function (l) {
      l.style.borderColor = 'rgba(var(--color-foreground), 0.1)';
      l.style.padding = '0px';
    });
    if (input.nextElementSibling) {
      input.nextElementSibling.style.borderColor = 'rgb(var(--color-foreground))';
      input.nextElementSibling.style.padding = '2px';
    }
  });
})();
